import React from "react";
import {Card, Divider, Col, Row, Empty  } from "antd";
// import "./CaseNotes.scss";
import utils from "utils";
import Loader from 'Components/Loader';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { PieChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TooltipComponent,
  TitleComponent,
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';
import { CONSTANTS } from "utils/constant";
echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  PieChart,
  CanvasRenderer,
]);
class Diagnosis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      update_diagnosis :false,
      isLoading:false,
      isDiagnosis_filled:false
    };
  }
    componentDidMount() {
        this.getDiagnosisQuestions(this.props?.data || {});
    }
    getDiagnosisQuestions(val) {
        let emotion_adult =  val?.assessment_results?.filter((item) => item.question_type == "emotion" && item.type == "adult");
        let stress_adult =  val?.assessment_results?.filter((item) => item.question_type == "stress" && item.type == "adult");
        let emotion_adolescent =  val?.assessment_results?.filter((item) => item.question_type == "emotion" && item.type == "adolescent");
          this.setState({
            isLoading: false,
            assessment: val || {},
            emotion_adult,stress_adult,emotion_adolescent
          });
    }
  render() {
    let a = { "0" : "#A7D6AA", "1" : "#FAC898", "2" : "#FF6961" }
    let option = {
      tooltip: {
        formatter: '{b}'
      },
      legend: {
        show:false
      },
      series: [
        {
          name: '',
          type: 'pie',
          radius: '70%',
          itemStyle: {
            borderRadius: 1,
            borderColor: '#fff',
            borderWidth: 2
          },
          data:    this.state?.emotion_adolescent?.length > 0 ? 
          [{ value: 1, name: `Anxiety`, itemStyle : {color:a[this.state?.emotion_adolescent[0]?.gad_score]}, tooltip: {formatter: `{b} : ${this.state?.emotion_adolescent[0]?.gad_result}`}},
          { value: 1, name: `Depression`  , itemStyle : {color:a[this.state?.emotion_adolescent[0]?.phq_score]}, tooltip: {formatter: `{b} : ${this.state?.emotion_adolescent[0]?.phq_result}`}},
          { value: 1, name: `ADHD` , itemStyle : {color:a[this.state.emotion_adolescent[0]?.adhd_score]}, tooltip: {formatter: `{b} : ${this.state?.emotion_adolescent[0]?.adhd_result}`}},
          { value: 1, name: `Psychosis` , itemStyle : {color:a[this.state.emotion_adolescent[0]?.psychosis_score]}, tooltip: {formatter: `{b} : ${this.state.emotion_adolescent[0]?.psychosis_result}`}},
          { value: 1, name: `Disruptive Behaviour Disorder` , itemStyle : {color:a[this.state.emotion_adolescent[0]?.disruptive_score]}, tooltip: {formatter: `{b} : ${this.state.emotion_adolescent[0]?.disruptive_result}`}}, 
          { value: 1, name: `Learning Disorder` , itemStyle : {color:a[this.state.emotion_adolescent[0]?.learning_score]}, tooltip: {formatter: `{b} : ${this.state.emotion_adolescent[0]?.learning_result}`}},
          { value: 1, name: `Eating Disorder` , itemStyle : {color:a[this.state.emotion_adolescent[0]?.eating_score]} , tooltip: {formatter: `{b} : ${this.state.emotion_adolescent[0]?.eating_result}`}},
          { value: 1, name: `Internet Gaming Disorder` , itemStyle : {color:a[this.state.emotion_adolescent[0]?.gaming_score]} , tooltip: {formatter: `{b} : ${this.state.emotion_adolescent[0]?.gaming_result}`}}
          ] :
          [],       
          emphasis: {
            itemStyle: {
              // shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          },
        }
      ]
    };
    return (
    <>
        {this.state.isLoading?<Loader/>:
            <>
                  <div>
                    <Card size="small" title={"Assessment Details"} bordered={false} hoverable={false}>
                    <>
                    <div className={(this.props.type == "adult") ? "score-container" : ""}>
                    {(this.props.type == "adult")  ? 
                    <>
                    <Divider orientation="left">Depression / Anxiety</Divider>
                    {(this.state?.emotion_adult?.length > 0) ?
                    <>                    
                    <Row gutter={24} >
                      <Col span={8}>{CONSTANTS.ASSESSED_ON} {utils.FormatDate(this.state?.emotion_adult[0]?.assessment_date,"DATE_14")}</Col>
                      {/* <Col span={8}>{CONSTANTS.TAKE_ASSESSMENT_FROM} {utils.FormatDate(this.state?.assessment?.next_emotion_date,"DATE_14")}</Col> */}
                    </Row>
                    <Row gutter={24}>                    
                    <Col span={8}>
                    <Card  hoverable={false}
                     className={`score-detail ${this.state?.emotion_adult[0]?.phq_score == 0 ? "card-11" : this.state?.emotion_adult[0]?.phq_score <= 4 ? 'card-2'
                     : this.state?.emotion_adult[0]?.phq_score <= 9 ? 'card-3' : this.state?.emotion_adult[0]?.phq_score <= 14 ? 'card-4' : this.state?.emotion_adult[0]?.phq_score <= 19 ? 'card-5' : 'card-6'}`}
                    size="small"
                    >
                <div>Depression</div>
                <div style={{fontSize:"25px"}}>{this.state?.emotion_adult[0]?.phq_score}</div>
                <div>{this.state?.emotion_adult[0]?.phq_result}</div>
               </Card>
               </Col> 
               <Col span={8}>
               <Card  hoverable={false}
                      className={`score-detail ${this.state?.emotion_adult[0]?.gad_score == 0 ? "card-11" :
                      this.state?.emotion_adult[0]?.gad_score <= 5 ? 'card-2' : this.state?.emotion_adult[0]?.gad_score <= 9 ? 'card-3' :
                          this.state?.emotion_adult[0]?.gad_score <= 13 ? 'card-4' : this.state?.emotion_adult[0]?.gad_score <= 17 ? 'card-5' : 'card-6'}`}
                    size="small">
                <div>Anxiety</div>
                <div style={{fontSize:"25px"}}>{this.state?.emotion_adult[0]?.gad_score}</div>
                <div>{this.state?.emotion_adult[0]?.gad_result}</div>
               </Card></Col></Row>
                {/* <Row gutter={24} >
                      <Col span={8}>{CONSTANTS.TAKE_ASSESSMENT_FROM} {utils.FormatDate(this.state?.assessment?.next_emotion_date,"DATE_14")}</Col>
                </Row> */}
                    </> : !this.state?.assessment?.is_emotion_eligible ?  
                    <Col span={24}> 
                    <Empty description={"Depression / Anxiety assessment not enabled."} /> 
                    </Col>
                    :<Col span={24}> 
                    <Empty description={"Depression / Anxiety assessment not taken."} image={Empty.PRESENTED_IMAGE_SIMPLE} /> 
                    </Col>
              }
              
              <Divider orientation="left">Stress</Divider>
               {(this.state?.stress_adult?.length > 0) ? <> 
                    <Row gutter={24}>
                      <Col span={8}>{CONSTANTS.ASSESSED_ON} {utils.FormatDate(this.state?.stress_adult[0]?.assessment_date,"DATE_14")}</Col>
                      {/* <Col span={8}>{CONSTANTS.TAKE_ASSESSMENT_FROM} {utils.FormatDate(this.state?.assessment?.next_stress_date,"DATE_14")}</Col> */}
                    </Row> 
                    <Row gutter={16}>                    
                  {this.state?.stress_adult?.length > 0  ? <Col span={8}><Card className={`score-detail ${this.state?.stress_adult[0]?.score == 0 ? "card-11" :
                                this.state?.stress_adult[0]?.score <= 6 ? 'card-2' :
                                this.state?.stress_adult[0]?.score <= 12 ? 'card-4' : 'card-6'}`} size="small" hoverable={false}>
                <div>Stress</div>
                <div style={{fontSize:"25px"}}>{this.state?.stress_adult[0]?.stress_score}</div>
                <div>{this.state?.stress_adult[0]?.stress_result}</div>
               </Card></Col> :<Col span={24}> <Empty
                description={"Stress assessment not taken."}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              /> </Col>}
               
                </Row>
                {/* <Row gutter={24} >
                      <Col span={8}>{CONSTANTS.TAKE_ASSESSMENT_FROM} {utils.FormatDate(this.state?.assessment?.next_stress_date,"DATE_14")}</Col>
                </Row> */}
                </> :  !this.state?.assessment?.is_stress_eligible ?  
                    <Col span={24}> 
                    <Empty
                description={"Stress assessment not enabled."} /> 
                    </Col>
                    : <Col span={24}> <Empty
                description={"Stress assessment not taken."}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              /> </Col>}
                </> 
               : 
               <div style={{ display:"flex", flexDirection:"column",alignItems:"center"}}><div style={{"width":"80%",}}>           
               {this.state?.emotion_adolescent?.length > 0 ? 
               <>
                <Row gutter={24} justify="space-around">
                      <Col >{CONSTANTS.ASSESSED_ON} {utils.FormatDate(this.state?.emotion_adolescent[0]?.assessment_date,"DATE_14")}</Col>
                      {/* <Col >{CONSTANTS.TAKE_ASSESSMENT_FROM} {utils.FormatDate(this.state?.assessment?.next_emotion_date,"DATE_14")}</Col> */}
              </Row>
               <ReactEChartsCore
                 echarts={echarts}
                 option={option}
                 notMerge={true}
                 lazyUpdate={true}
                 opts={{}}
               />
               {/* <Row gutter={24} justify="space-around">
                      <Col >{CONSTANTS.TAKE_ASSESSMENT_FROM} {utils.FormatDate(this.state?.assessment?.next_emotion_date,"DATE_14")}</Col>
              </Row>  */}
               </>
               :   !this.state?.assessment?.is_emotion_eligible ?  
               <Col span={24}> 
               <Empty
                description={"Assessment not enabled yet."} /> 
               </Col>: <Col span={24}> <Empty
               description={"Assessment not taken yet."}
               image={Empty.PRESENTED_IMAGE_SIMPLE}
                /></Col>}
                </div></div>}
               </div>
         </>
                    </Card>
                  </div>
          </>
        }
    </>
    );
  }
}

export default Diagnosis;

